import axios from 'axios'
import qs from 'qs'
import { getLocationHash } from './Common.js'

// 设置默认请求头
// axios.defaults.headers = {
//   'X-Requested-With': 'XMLHttpRequest'
// }
axios.defaults.timeout = 30000

/*
 * 统一封装axios方法
 * @param url: 请求地址
 * @param param: 请求参数
 * @param callback: 回调函数
 * @param location: 请求时的路由，用来处理由于响应时间过长，点击其他页面带来的影响
 */
export const post = function (url, param, callback, location) {
  if (!localStorage.getItem('pcVersion')) {
    param['useragent'] = 'web'
  } else {
    param['useragent'] = localStorage.getItem('pcVersion')
  }
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(param))
    .then((res) => {
      if (getLocationHash() === location || location === void 0) {
        if (callback) callback(res.data.msg, res.data.status, res.data.payload)
        if (Object.is(res.data.status, '0')) {
          resolve(res)
        } else {
          reject(res)
          console.error(res.data.msg)
        }
      }
    })
    .catch((err) => {
      // if (callback) callback('Oops, an unexpected error occurred. Please try again.')
      reject(err)
      console.error(err)
      // this.$message({
      //   message: 'ERROR!',
      //   type: 'error'
      // })
    })
  })
}

// 判断账号是否需要扫码的通用接口
export const checkScan = async function (route, param, callback, location) {
  let res = await post('/proxy-api/client/web/index/check-need-scan', param, callback, location)
  if (res.data.payload.need_scan === 1) {
    route['path'] = '/login/scan'
    return route
  } else {
    route['path'] = '/login/password'
    return route
  }
}



// WEBPACK FOOTER //
// ./src/new-login-2018/common/Axios.js